import useSWR from "swr";
import { api } from "../services";

const BASE_URL = "/accounting/employee-salary";

export const useEmployeeSalary = ( query = {} ) => {
  const qs = new URLSearchParams(query).toString();
  const { data, isLoading, mutate } = useSWR(`${BASE_URL}?${qs}`, api.get);

  const create = async (data) => {
    const employeeSalary = await api.post(BASE_URL, data);
    return employeeSalary;
  };

  const update = async (data) => {
    const employeeSalary = await api.put(BASE_URL, data);
    return employeeSalary;
  };

  return {
    isLoading,
    data: data,
    count: data?.length,
    mutate,
    create,
    update,
  };
};